import { Component, OnInit, Inject } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';



@Component({
  selector: 'ebb-dialog-contractor-reviews',
  templateUrl: './dialog-contractor-reviews.component.html',
  styleUrls: ['./dialog-contractor-reviews.component.scss']
})
export class DialogContractorReviewsComponent implements OnInit {
  public showMore: boolean;
  public reviews: Array<{
    id: string;
    toggle: boolean;
    }> = [];
  constructor(
    public dialogRef: MatDialogRef<DialogContractorReviewsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly dialogContractorReviewResponse: MatDialog
  ) {}

  ngOnInit() {
    this.showMore = false;
    this.data.reviews.forEach(x => {
      var review = { id: x.id, toggle: false };
      this.reviews.push(review);
    });
  }

  onClose(): void {
    this.dialogRef.close(true);
  }

  onMore(): void {
    this.showMore = true;
  }
  public canShowResponse(data: any): boolean {
    if (data.response == null) {
      return false;
    }
    if ( data.response.length > 0) {
      return true;
    }

    return false;
  }

  toggleCollapse(id): boolean {
    if (this.reviews.length > 0) {
      let index = this.reviews.findIndex(x => x.id == id);
      var value = this.reviews[index].toggle;

      return value;
    }
    return false;
  }
  updateToggleCollapse(id) {
    if (this.reviews.length > 0) {
      let index = this.reviews.findIndex(x => x.id == id);
      this.reviews[index].toggle = !this.reviews[index].toggle;
    }
    return false;
  }
}
